import { styled } from "@mui/material";
import { Colors } from "../theme";
import { Opacity } from "@mui/icons-material";

export const CourseCardContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: Colors.white,
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  overflow: "hidden",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  width: "100%",
  border: "1px solid " + Colors.border,
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 16px rgba(0, 0, 0, 0.05)",
  },
  ".course-image": {
    width: "100%",
    height: "180px",
    objectFit: "cover",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid " + Colors.text,
  },
  ".thumbnail": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "7px 7px 0 0",
  },
  ".course-icon": {
    fontSize: "60px",
  },
  ".course-content": {
    padding: "15px",
  },
  ".course-title": {
    fontSize: "18px",
    fontWeight: "600",
    marginBottom: "8px",
    color: Colors.black,
  },
  ".course-description": {
    fontSize: "14px",
    color: Colors.garyText,
    marginBottom: "12px",
    lineHeight: "1.5",
  },
  ".course-meta": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "8px",
    fontSize: "13px",
    color: Colors.garyText,
  },
  ".category-tag": {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 15px",
    backgroundColor: Colors.text,
    borderRadius: "20px",
    fontWeight: "500",
    color: Colors.garyText,
    fontSize: "12px",
  },
  ".course-actions": {
    height: "fit-content",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 20px",
    borderTop: "1px solid " + Colors.text,
  },
  ".action-btn": {
    background: Colors.text,
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: Colors.garyText,
    padding: "8px 12px",
    borderRadius: "4px",
    fontSize: "14px",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
    },
  },
  ".bookmark-btn": {
    background: "none",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: Colors.garyText,
    padding: "8px",
    borderRadius: "50%",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  ".bookmarked": {
    color: Colors.primary,
  },
});

export const CategoryCardContainer = styled("div")({
  width: "100%",
  "& .category-card": {
    padding: "20px",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    border: "1px solid " + Colors.border,
    cursor: "pointer",
    overflow: "hidden",
    transition: "transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease",

    fontSize: "14px",
    color: Colors.garyText,
    "&:hover": {
      opacity:"0.9",
      transform: "translateY(-2px)",
    },
    "& .title": {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "8px",
    },
    "& .description": {
      fontSize: "12px",
      marginBottom: "14px",
    },
  },
});
